import { setFilterDeleteRowData } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';


export type SetFilterDeleteRowProps = ApiMethodBase & {
    row: number;
};

export const setFilterDeleteRow = ({
    row,
}: SetFilterDeleteRowProps) => {
    setFilterDeleteRowData(row);
};
